import { render, staticRenderFns } from "./node-element-article-carousel.vue?vue&type=template&id=4012b856&scoped=true"
import script from "./node-element-article-carousel.vue?vue&type=script&lang=js"
export * from "./node-element-article-carousel.vue?vue&type=script&lang=js"
import style0 from "./node-element-article-carousel.vue?vue&type=style&index=0&id=4012b856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4012b856",
  null
  
)

export default component.exports